<div
  *ngFor="let categoryResult of categoryResults"
  [style.background-color]="categoryResult.evaluation.backgroundColor"
  class="text-center py-2"
  [style.width]="comparison ? '55px' : '60px'"
>
  <img [src]="materialServer + categoryResult.category.inactiveIconUrl" alt="icon" />
</div>
